import React, { useCallback, useRef } from 'react';

import { SuggestAsync } from '.';
import { api } from '../../../../helpers/client';
import { AddressSuggestBound } from '../../../../services/dadata/types';
import { ISuggestProps } from './types';
import { splitAddressToSuggest } from '../../../../helpers/validations/simple';

type IAddressSuggestProps<T> = {
    toBound?: AddressSuggestBound;
} & Omit<ISuggestProps<T>, 'options'>;

export const FormAddressSuggest = ({ toBound, ...props }: IAddressSuggestProps<Dadata.AddressSuggestItem>) => {
    const lastPartRef = useRef('');

    const getOptions = useCallback(
        (value) => {
            const [firstPart, lastPart] = splitAddressToSuggest(value);
            lastPartRef.current = lastPart;
            return api.addressSuggest(firstPart, toBound).then((options) => (lastPart ? options.slice(0, 1) : options));
        },
        [toBound],
    );

    return (
        <SuggestAsync<Dadata.AddressSuggestItem>
            {...props}
            getOptions={getOptions}
            onlyRus
            input={props.input}
            mapperOption={(option) => {
                const { data = {} as any } = option;
                return {
                    name: data.city || data.settlement || data.region,
                    value: lastPartRef.current ? `${option.value}, ${lastPartRef.current}` : option.value,
                    option,
                };
            }}
        />
    );
};
